import React, {useId} from 'react';

import SwitchToggle from '@/components/ui/SwitchToggle/SwitchToggle';
import {twx} from '@/utils/tailwindUtils';

const DeviceSettingsSwitchItem = ({title, isActive, onChange, className, isDisabled, onDisabledClick}) => {
    const labelId = useId();
    const inputId = useId();

    return (
        <div className={twx('flex items-center justify-between gap-2 p-4', className)}>
            <label id={labelId} htmlFor={inputId} className={twx('text-16', isDisabled && 'text-primary-dark-85')}>
                {title}
            </label>
            <SwitchToggle
                id={inputId}
                labelId={labelId}
                isActive={isActive}
                onChange={onChange}
                className='p-0 md:pr-0'
                isDisabled={isDisabled}
                onDisableClick={onDisabledClick}
            />
        </div>
    );
};

export default DeviceSettingsSwitchItem;
